export const environment = {
    production: true,
    baseHref: '/CSDA',
    apiBase: 'https://mydashgis.com/CSDA',
    debug: true,
};
